module.exports = __webpack_public_path__ + "static/img/specialty.5e0831d1.png";